export default __webpack_public_path__ + "static/holborn-board-room-4c581c0fa8141daf6364e541e303f99a.webp";